/**
 * Calendar-day cache for the dashboard "התקדמות מכירות חודשית" card.
 * Hydrate synchronously on mount; refresh only when the local day rolls over (midnight).
 */

import { resolveHomeDashboardCacheAgentKey } from "./homeDashboardCache";

const CACHE_PREFIX = "hr_billing_exemption_day_v1_";

export { resolveHomeDashboardCacheAgentKey as resolveBillingExemptionCacheAgentKey };

/** Local calendar day YYYY-MM-DD (browser timezone). */
export function localCalendarDayKey(now = new Date()) {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** Milliseconds until next local midnight (+ small buffer so day key flips cleanly). */
export function msUntilNextLocalMidnight(now = new Date()) {
  const next = new Date(now);
  next.setHours(24, 0, 0, 0);
  return Math.max(0, next.getTime() - now.getTime()) + 50;
}

function cacheKey(agentKey) {
  return `${CACHE_PREFIX}${String(agentKey || "anon").trim().toLowerCase()}`;
}

/**
 * @returns {{
 *   dayKey: string,
 *   savedAt: number,
 *   payload: object,
 *   source: string,
 * } | null}
 */
export function readBillingExemptionDailyCache(agentKey, now = new Date()) {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(cacheKey(agentKey));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    const dayKey = String(parsed.dayKey || "").trim();
    if (!dayKey || dayKey !== localCalendarDayKey(now)) return null;
    if (!parsed.payload || typeof parsed.payload !== "object") return null;
    return {
      dayKey,
      savedAt: Number(parsed.savedAt) || 0,
      payload: parsed.payload,
      source: String(parsed.source || "daily_cache").trim() || "daily_cache",
    };
  } catch {
    return null;
  }
}

export function writeBillingExemptionDailyCache(agentKey, payload, source, now = new Date()) {
  if (typeof window === "undefined") return;
  if (!payload || typeof payload !== "object") return;
  try {
    const body = {
      dayKey: localCalendarDayKey(now),
      savedAt: Date.now(),
      source: String(source || "daily_cache").trim() || "daily_cache",
      payload,
    };
    window.localStorage.setItem(cacheKey(agentKey), JSON.stringify(body));
  } catch {
    // quota / private mode — ignore
  }
}

export function clearBillingExemptionDailyCache(agentKey) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(cacheKey(agentKey));
  } catch {
    /* ignore */
  }
}
